import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
/** helper to put elements in a footer, eg; controls  */
export const Footerify = (props) => {
    const { children, sx, ...rest } = props;
    return (_jsx(Box, { sx: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            width: '100vw',
            boxSizing: 'border-box',
            background: 'white',
            zIndex: 60,
            boxShadow: 3,
            p: 2,
            overflowX: 'auto', // or 'hidden'
            maxWidth: '100vw',
            ...sx,
        }, ...rest, children: children }));
};
